<form [formGroup]="form" class="app-install-trigger-form off-property-trigger-form">

  <app-flow-test-device-section
    [group]="$any(form.get('device'))"
    [modeOptions]="deviceModeOptions"
  ></app-flow-test-device-section>

  <app-flow-test-app-state-section
    [group]="$any(form.get('accountAppDevice'))"
    [modeOptions]="appStateModeOptions"
    [locationPermissionOptions]="locationPermissionOptions"
  ></app-flow-test-app-state-section>

  <app-flow-test-customer-section
    [group]="$any(form.get('accountAppUser'))"
    [modeOptions]="customerModeOptions"
    [userSearchTerm]="userSearchTerm"
    [userSearchResults]="userSearchResults"
    [userSearchLoading]="userSearchLoading"
    [selectedUser]="selectedUser"
    (searchInput)="onUserSearchInput($event)"
    (userPicked)="pickUser($event)"
    (userCleared)="clearUser()"
  ></app-flow-test-customer-section>

  <section formGroupName="offPropertyTiming" class="section">
    <header class="section-header">
      <h4>Off-Property Timing</h4>
      <span class="hint">Required</span>
    </header>

    <div class="mode-toggle">
      <app-trigger-mode-radio-group
        formControlName="mode"
        [options]="timingModeOptions"
      ></app-trigger-mode-radio-group>
    </div>

    <p class="hint" *ngIf="timingMode === 'generate'">
      The runner will seed a closed on-property visit with 30 minutes on
      property and 1 minute off property.
    </p>

    <div class="fields" *ngIf="timingMode === 'specify'">
      <div class="field">
        <label>Time On Property (minutes)</label>
        <mat-form-field appearance="outline">
          <input matInput type="number" formControlName="time_on_property_minutes" />
        </mat-form-field>
      </div>

      <div class="field">
        <label>Time Off Property (minutes)</label>
        <mat-form-field appearance="outline">
          <input matInput type="number" formControlName="time_off_property_minutes" />
        </mat-form-field>
      </div>
    </div>

    <p class="hint" *ngIf="timingMode === 'specify'">
      These values determine <code>entry_at</code>, <code>exit_at</code>,
      <code>last_on_property</code>, and <code>last_off_property</code> for
      time-on-station and last-visit conditions.
    </p>
  </section>
</form>
